import {changeRegion, firstOrUndefined, Person} from "@ots-frontend/ots-data";
import {createAction} from "@reduxjs/toolkit";
import {AppThunkDispatch} from "../store";

export const setAuthCredentials = createAction<{
  authToken: string,
  user: Person | undefined
}>("auth/setAuthCredentials");

export const setAuthUser = createAction<Person>("auth/setAuthUser");
export const setAuthToken = createAction<string>("auth/setAuthToken");

export const logout = createAction("auth/logout");

export const setAuthCredentialsAndLoadData = (creds: {
  authToken: string,
  user: Person
}) => (dispatch: AppThunkDispatch) => {
  dispatch(setAuthCredentials({...creds}));
  dispatch(changeRegion(firstOrUndefined(creds.user.regionList)));
  return dispatch(loadBaseData());
};

export const loadBaseData = () => (dispatch: AppThunkDispatch) => {
  return {}
}
